import { gql } from "@apollo/client";

export const GET_DASHBOARD_VALUE = gql`
  query {
    getAdminDashboardMetricValues {
      totalUser
      totalProduct
      totalProductOrder
      totalServiceOrder
      totalRevenue
    }
  }
`;

export const GET_REVENUE_METRICS = gql`
  query {
    getRevenueAnalysisByDateFilter(dateFilter: "MTD") {
      currentValue
      previousValue
      percentage
      currencySymbol
    }
  }
`;
export const GET_ORDER_METRICS = gql`
  query {
    getOrderAnalysisByDateFilter(dateFilter: "7") {
      currentValue
      previousValue
      percentage
      currencySymbol
    }
  }
`;

export const GET_USER_METRICS = gql`
  query {
    getUserAnalysisByDateFilter(dateFilter: "YTD") {
      currentValue
      previousValue
      percentage
      currencySymbol
    }
  }
`;

export const GET_TOP_10 = gql`
  query {
    getTopSalesProductsAndTotalNumberSold {
      product {
        name
        images
        categories {
          name
        }
        currency {
          symbol
          shortCode
          alias
        }
      }
      totalSold
    }
  }
`;

export const GET_TOP_CATEGORIES = gql`
  query GetTopSellingProductCategories {
    getTopSellingProductCategories {
      totalSold
      category {
        createdAt
        updatedAt
        _id
        name
        image
        description
        isActive
        isForService
      }
    }
  }
`;

export const GET_TOP_SELLER = gql`
  query GetTopSellers {
    getTopSellers {
      totalOrders
      totalAmount
      seller {
        createdAt
        updatedAt
        _id
        uuid
        firstName
        lastName
        role
        imageUrl
        email
        phone
        sex
        dateOfBirth
        referralCode
        isDeleted
        previousEmail
        previousPhone
        verifiedAt
        profileStatus
        activityStatus
        coordinates
        registrationSource
        hasPaidMembershipFee
        hasRegistered
        hasCompletedSellerVerification
        stripeAccountId
        referred
      }
    }
  }
`;

const createUserListQuery = (operationName, queryFilter) => gql(`
  query ${operationName}($page: Float, $limit: Float) {
    listAllUsers(query: ${queryFilter}, pageOptions: { page: $page, limit: $limit }) {
      items {
        _id
        imageUrl
        uuid
        firstName
        lastName
        email
        phone
        profileStatus
        activityStatus
        hasCompletedSellerVerification
        hasPaidMembershipFee # this is used ti determine if a User is also a Buyer or not
        coordinates
        addresses {
          city {
            name
            state {
              name
              country {
                name
              }
            }
          }
        }
        createdAt
      }
      pagination
    }
  }
`);

export const GET_USER_LIST = createUserListQuery("GetUserList", "{}");
export const GET_BUYERS_LIST = createUserListQuery("GetBuyersList", "{ hasPaidMembershipFee: false }");
export const GET_SELLERS_LIST = createUserListQuery("GetSellersList", "{ hasPaidMembershipFee: true }");
export const GET_INACTIVE_USERS_LIST = createUserListQuery("GetInactiveUsersList", '{ activityStatus: "BLOCKED" }');
export const GET_USER_MAMAPURSE = gql`
  query user($userId: String!) {
    getUserMamapurseBalanceInformationByUserId(payload: { userId: $userId }) {
      totalCredited
      totalDebited
      balance
    }
  }
`;
export const GET_USER_STORE = gql`
  query user($userId: String!) {
    getUserStoreBalanceInformationByUserId(payload: { userId: $userId }) {
      totalEarned
      totalWithdrawn
      balance
    }
  }
`;
export const GET_USER_TRANSACTIONS = gql`
  query user($userId: String!) {
    fetchWalletTransactionsByUserId(
      payload: { userId: $userId, isStoreTransaction: false }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        externalReference
        amount
        action
        type
        isStoreTransaction
        createdAt
        currency {
          shortCode
          symbol
        }
      }
      pagination
    }
  }
`;

export const GET_USER_PRODUCT_ORDER = gql`
  query user($userId: String!) {
    fetchProductOrdersByUserId(
      payload: { userId: $userId }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        amountPaid
        quantity
        pricePerUnit
        status
        product {
          name
          images
        }
        buyer {
          _id
          firstName
          lastName
          email
          phone
        }
        seller {
          _id
          firstName
          lastName
          email
          phone
        }
        order {
          _id
          reference
          paymentMethod
        }
      }
      pagination
    }
  }
`;

export const GET_USER_SERVICE_ORDER = gql`
  query user($userId: String!) {
    fetchServiceOrdersByUserid(
      payload: { userId: $userId }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        totalPrice
        offerAmount
        status
        service {
          _id
          reference
          title
          rateType
          images
          price
          status
        }
        buyer {
          _id
          firstName
          lastName
          email
          phone
        }
        seller {
          _id
          firstName
          lastName
          email
          phone
        }
      }
      pagination
    }
  }
`;

export const GET_USER_PRODUCTS = gql`
  query user($userId: String!) {
    fetchProductsByUserId(
      payload: { userId: $userId }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        reference
        name
        alias
        price
        description
        isNegotiable
        isInStock
        rating
        status
        images
        categories {
          _id
          name
        }
        subCategories {
          _id
          name
        }
        merchant {
          _id
          firstName
          lastName
        }
        currency {
          name
          symbol
        }
        country {
          _id
          name
        }
      }
      pagination
    }
  }
`;

export const GET_USER_SERVICE = gql`
  query user($userId: String!) {
    fetchUserServicesByUserId(
      payload: { userId: $userId }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        title
        description
        status
        images
        price
        isNegotiable
        rateType
        user {
          firstName
          lastName
          phone
          email
        }
        currency {
          _id
          name
          symbol
          shortCode
        }
        city {
          _id
          name
        }
        state {
          _id
          name
        }
        country {
          name
        }
      }
      pagination
    }
  }
`;

export const GET_SINGLE_USER = gql`
  query listAllUsers($_id: String!) {
    listAllUsers(query: { _id: $_id }, pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        imageUrl
        uuid
        firstName
        lastName
        email
        phone
        profileStatus
        activityStatus
        hasCompletedSellerVerification
        hasPaidMembershipFee # this is used ti determine if a User is also a Buyer or not
        coordinates
        addresses {
          city {
            name
            state {
              name
              country {
                name
              }
            }
          }
        }
        createdAt
      }
      pagination
    }
  }
`;

export const GET_CATEGORIES = gql`
  query {
    getCategories(query: {}) {
      _id
      name
      image
      description
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const GET_BLOGS = gql`
  query FetchBlogs($search: String, $category: String, $status: String) {
    fetchBlogs(
      query: { search: $search, category: $category, status: $status }
      pageOptions: { page: null, limit: null }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        title
        slug
        imageUrl
        content
        category
        status
        isDeleted
        description
      }
    }
  }
`;

export const GET_SUB_CATEGORIES = gql`
  query getSub($category: String!) {
    getSubCategories(query: { category: $category }) {
      _id
      name
      description
      isActive
      createdAt
      updatedAt
      category {
        _id
        name
        image
      }
    }
  }
`;

export const GET_PROFILE = gql`
  query {
    getAdminProfile {
      userType
      profile {
        _id
        uuid
        firstName
        lastName
        email
        phone
        role {
          title
        }
        activityStatus
        createdAt
        updatedAt
        country {
          name
          alias
        }
      }
    }
  }
`;

export const GET_TEAMS = gql`
  query {
    fetchTeamsWithFilter(
      query: { textToSearch: "ACTIVE" }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        uuid
        firstName
        lastName
        email
        phone
        imageUrl
        activityStatus
        role {
          title
          _id
        }
        createdAt
        updatedAt
        country {
          name
        }
      }
      pagination
    }
  }
`;

export const GET_ROLES = gql`
  query {
    getAdminRoles {
      _id
      title
      description
    }
  }
`;

export const GET_BANNER = gql`
  query {
    fetchBanners(query: {}) {
      _id
      type
      imageUrl
    }
  }
`;

export const GET_PRODUCTS = gql`
  query GetProducts($page: Float!, $limit: Float!, $textToSearch: String) {
    fetchProductsWithFilter(
      query: { textToSearch: $textToSearch }
      pageOptions: { page: $page, limit: $limit }
    ) {
      items {
        _id
        name
        price
        description
        isInStock
        status
        reference
        createdAt
        categories {
          _id
          name
        }
        subCategories {
          _id
          name
        }
        merchant {
          _id
          firstName
          lastName
        }
        currency {
          name
          symbol
        }
        country {
          _id
          name
        }
      }
      pagination
    }
  }
`;
export const GET_PRODUCTS_BY_DATERANGE = gql`
  query GetProductsByDateRange(
    $dateRangeKey: String!
    $page: Float!
    $limit: Float!
    $textToSearch: String
  ) {
    fetchProductsWithFilter(
      query: { dateRangeKey: $dateRangeKey, textToSearch: $textToSearch }
      pageOptions: { page: $page, limit: $limit }
    ) {
      items {
        _id
        name
        price
        description
        isInStock
        status
        reference
        createdAt
        categories {
          _id
          name
        }
        subCategories {
          _id
          name
        }
        merchant {
          _id
          firstName
          lastName
        }
        currency {
          name
          symbol
        }
        country {
          _id
          name
        }
      }
      pagination
    }
  }
`;

export const GET_CATEGORIES_N_SUB = gql`
  query {
    fetchAllCategoriesAndTheirSubCategories {
      category {
        _id
        name
        isActive
      }
      subCategories {
        _id
        name
        description
      }
    }
  }
`;

export const GET_PRODUCT_ORIGIN = gql`
  query {
    getProductOrigins(query: {}, pageOptions: { page: 1, limit: 1000 }) {
      items {
        _id
        name
        flagUrl
      }
      pagination
    }
  }
`;
export const GET_SINGLE_PRODUCTS = gql`
  query fetchProduct($textToSearch: String!) {
    fetchProductsWithFilter(
      query: { textToSearch: $textToSearch }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        name
        price
        images
        description
        isInStock
        isNegotiable
        status
        quantityInStock
        weight
        totalViews
        stockHistory {
          quantity
          initialQuantity
        }
        categories {
          _id
          name
        }
        subCategories {
          _id
          name
        }
        merchant {
          _id
          firstName
          lastName
          createdAt
        }
        currency {
          name
          symbol
        }
        country {
          _id
          name
        }
      }
      pagination
    }
  }
`;

export const GET_SERVICES = gql`
  query {
    fetchAllServicesWithFilter(
      query: { textToSearch: "APPROVED" }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        title
        description
        status
        images
        price
        isNegotiable
        rateType
        createdAt
        user {
          firstName
          lastName
          phone
          email
        }
        currency {
          _id
          name
          symbol
          shortCode
        }
        city {
          _id
          name
        }
        state {
          _id
          name
        }
        country {
          name
        }
      }
      pagination
    }
  }
`;
export const GET_SINGLE_SERVICES = gql`
  query fetchProduct($textToSearch: String!) {
    fetchAllServicesWithFilter(
      query: { textToSearch: $textToSearch }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        title
        description
        status
        images
        price
        isNegotiable
        rateType
        createdAt
        user {
          firstName
          lastName
          phone
          email
          _id
          createdAt
        }
        currency {
          _id
          name
          symbol
          shortCode
        }
        city {
          _id
          name
        }
        state {
          _id
          name
        }
        country {
          name
        }
      }
      pagination
    }
  }
`;
export const GET_SERVICES_DATE = gql`
  query fetch($dateRangeKey: String!) {
    fetchAllServicesWithFilter(
      query: { dateRangeKey: $dateRangeKey, textToSearch: "APPROVED" }
      pageOptions: { page: 1, limit: 25 }
    ) {
      items {
        _id
        title
        description
        status
        images
        price
        isNegotiable
        rateType
        createdAt
        user {
          firstName
          lastName
          phone
          email
        }
        currency {
          _id
          name
          symbol
          shortCode
        }
        city {
          _id
          name
        }
        state {
          _id
          name
        }
        country {
          name
        }
      }
      pagination
    }
  }
`;

export const GET_PRODUCT_ORDERS = gql`
query  {
  fetchOrdersByAdmin(
    pageOptions: { page: 1, limit: 25 }, 
    query: {
        
    #   customDateFilter: {
    #     fromDate: "2023-07-01",
    #     toDate: "2023-08-31"
    #   }
    }) {
    items {
      _id
      reference
      amountPaid
      quantity
      pricePerUnit
      status
      product {
        name
        images
      }
      buyer {
        _id
        firstName
        lastName
        email
        phone
      }
      createdAt
      seller {
        _id
        firstName
        lastName
        email
        phone
      }
    }
    pagination
  }
}
`;

export const GET_SERVICE_ORDER = gql`
  query {
    fetchServiceOrdersByAdmin(
      pageOptions: { page: 1, limit: 25 }
      query: {
        # textToSearch: "65c87cc4054107e37a69f6e3"
        # dateRangeKey: "60",
        customDateFilter: { fromDate: "2023-07-01", toDate: "2024-08-31" }
      }
    ) {
      items {
        _id
        reference
        totalPrice
        offerAmount
        status
        createdAt
        service {
          _id
          reference
          title
          rateType
          images
          price
          status
        }
        buyer {
          _id
          firstName
          lastName
          email
          phone
        }
        seller {
          _id
          firstName
          lastName
          email
          phone
        }
      }
      pagination
    }
  }
`;

export const GET_SINGLE_SERVICE_ORDER = gql`
  query fetchOrder($textToSearch: String!) {
    fetchServiceOrdersByAdmin(
      pageOptions: { page: 1, limit: 25 }
      query: {
        textToSearch: $textToSearch
        # dateRangeKey: "60",
        customDateFilter: { fromDate: "2023-07-01", toDate: "2024-08-31" }
      }
    ) {
      items {
        _id
        reference
        totalPrice
        offerAmount
        status
        createdAt
        service {
          _id
          reference
          title
          rateType
          images
          price
          status
        }
        buyer {
          _id
          firstName
          lastName
          email
          phone
        }
        seller {
          _id
          firstName
          lastName
          email
          phone
        }
      }
      pagination
    }
  }
`;
export const GET_SINGLE_PRODUCT_ORDERS = gql`
  query fetchOrdersByAdmin($_id: String!) {
    fetchOrdersByAdmin(
      pageOptions: { page: 1, limit: 25 }
      query: { _id: $_id }
    ) {
      items {
        _id
        reference
        amountPaid
        quantity
        pricePerUnit
        status
        product {
          name
          images
        }
        buyer {
          _id
          firstName
          lastName
          email
          phone
        }
        createdAt
        seller {
          _id
          firstName
          lastName
          email
          phone
        }
      }
      pagination
    }
  }
`;

export const GET_MAMAPURSES_TRANSACTIONS = gql`
query {
  fetchWalletTransactionsWithFilter(
    query: {
    #   textToSearch: "65a67e7b4125992fa0a5e158",
    #   dateRangeKey: "60"
    },
    pageOptions: { page: 1, limit: 25 }
  ) {
    items {
      _id
      reference
      externalReference
      amount
      gateway
      description
      action
      type
      status
      paidAt
      createdAt
      updatedAt
      user {
        _id
        firstName
        lastName
        phone
        email
      }
      currency {
        _id
        name
        symbol
        alias
      }
    }
    pagination
  }
}
`;

export const GET_DELIVERY_STATS = gql`
  query FetchDeliveryStats {
    fetchDeliveryStats {
      noOfPendingDeliveries
      noOfCompletedDeliveries
      noOfTotalDeliveries
      noOfTotalDrivers
    }
  }
`;

export const GET_DELIVERIES = gql`
  query FetchDeliveriesWithFilter {
    fetchDeliveriesWithFilter(
      query: {}
      pageOptions: { limit: null, page: null }
    ) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        price
        status
        orderItem {
          createdAt
          updatedAt
          _id
          reference
          pricePerUnit
          amountPaid
          sellerAmount
          quantity
          weight
          status
        }
        product {
          createdAt
          updatedAt
          _id
          reference
          name
          alias
          description
          isNegotiable
          price
          weight
          quantityInStock
          isInStock
          images
          features
          boxContent
          rating
          status
          deletedAt
          totalViews
        }
        seller {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        buyer {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        driver {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          referralCode
          otp
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
        }
        pickupAddress {
          _id
          firstName
          lastName
          phone
          addressOne
          addressTwo
          isDefault
          zipCode
          createdAt
          updatedAt
        }
        shippingAddress {
          createdAt
          updatedAt
          _id
          firstName
          lastName
          phone
          addressOne
          addressTwo
          isDefault
          zipCode
        }
      }
    }
  }
`;

export const GET_DRIVERS = gql`
  query FetchDriversWithFilter {
    fetchDriversWithFilter(query: {}, pageOptions: { limit: 100, page: 1 }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        uuid
        firstName
        lastName
        role
        imageUrl
        email
        phone
        sex
        referralCode
        otp

        verifiedAt
        profileStatus
        activityStatus
        coordinates
        registrationSource
        hasPaidMembershipFee
        hasRegistered
        hasCompletedSellerVerification
        stripeAccountId
        driverProfile {
          createdAt
          updatedAt
          _id
          isPhoneNumberVerified
          isDriverLicenseVerified
          hasSetTransactionPin
          hasSetSettlementAccount
          driverLicenseNo
          backOfLicenseUrl
          frontOfLicenseUrl
        }
      }
    }
  }
`;

export const MAMAPURSE_BALANCE = gql`
  query {
    getAggregateWalletBalances {
      totalMamapurseBalance
      totalStoreBalance
      totalBalance
    }
  }
`;

export const ALL_BANNER = gql`
  query {
    fetchBanners(query: {}) {
      _id
      type
      imageUrl
      route
    }
  }
`;

export const GET_ACCOUNT_TYPE = gql`
  query {
    getUserTypes {
      key
      value
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query {
    fetchAllAdminNotifications(pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        accountType
        title
        content
        createdAt
        updatedAt
        isSent
      }
      pagination
    }
  }
`;

export const GET_ZIP_STATS = gql`
  query GetZipCodeStats {
    getZipCodeStats(pageOptions: { page: 1, limit: 5 }) {
      name
      value
      color
    }
  }
`;

export const GET_ZIP_STATS_2 = gql`
  query GetActiveZipCodeStats {
    getActiveZipCodeStats(pageOptions: { page: 1, limit: 5 }) {
      name
      value
      color
    }
  }
`;

export const GET_ZIP_TRACKER = gql`
 query FetchAllWaitlist {
    fetchAllWaitlist(pageOptions: { page: 1, limit: 100 }) {
      pagination
      
      items {
        createdAt
        updatedAt
        _id
        zipCode
        Interested
        description
        email
        currentSpend
        preferredSpend
        country {
          createdAt
          updatedAt
          _id
          name
          alias
          flagUrl
          productCount
        }
        categories {
          createdAt
          updatedAt
          _id
          name
          image
          description
          isActive
          isForService
        }
      }
    }
  }  
`;

export const GET_DISPUTED = gql`
  query {
    fetchDisputedOrders(
      filter: { filterBy: "All" }
      pageOptions: { page: 1, limit: 50 }
    ) {
      items {
        _id
        status
        dispute {
          reason
          reference
          isRead
          isResolved
          description
          files
          createdAt
          updatedAt
        }
        seller {
          firstName
          lastName
          phone
          profileStatus
          email
          createdAt
          _id
        }
        buyer {
          firstName
          lastName
          phone
          profileStatus
          email
          createdAt
          _id
        }
        product {
          _id
          name
          images
          price
        }
      }
      pagination
    }
  }
`;

export const GET_DISPUTE_HISTORY = gql`
  
query GetDisputeHistory {
    getDisputeHistory(pageOptions: { page: null, limit: null }) {
        pagination
        items {
            createdAt
            updatedAt
            _id
            reference
            reason
            description
            isRead
            isResolved
            files
            buyer {
                createdAt
                updatedAt
                _id
                uuid
                firstName
                lastName
                role
                imageUrl
                email
                phone
                sex
                dateOfBirth
                referralCode
                isDeleted
                previousEmail
                previousPhone
                verifiedAt
                profileStatus
                activityStatus
                coordinates
                registrationSource
                hasPaidMembershipFee
                hasRegistered
                hasCompletedSellerVerification
                stripeAccountId
                referred
            }
            seller {
                createdAt
                updatedAt
                _id
                uuid
                firstName
                lastName
                role
                imageUrl
                email
                phone
                sex
                dateOfBirth
                referralCode
                isDeleted
                previousEmail
                previousPhone
                verifiedAt
                profileStatus
                activityStatus
                coordinates
                registrationSource
                hasPaidMembershipFee
                hasRegistered
                hasCompletedSellerVerification
                stripeAccountId
                referred
            }
            orderItem {
                createdAt
                updatedAt
                _id
                reference
                pricePerUnit
                amountPaid
                sellerAmount
                quantity
                weight
                status
                product{
                    _id
                    reference
                    name
                    alias
                    description
                    isNegotiable
                    isDeleted
                    price
                    weight
                    quantityInStock
                    isInStock
                    images
                    features
                    boxContent
                    rating
                    status
                    deletedAt
                    totalViews
                    isFavourite
                }
            }
        }
    }
}
`;

export const GET_ALL_REQUEST = gql`
  query {
    fetchAllPendingWithdrawals(query: {}, pageOptions: { page: 1, limit: 25 }) {
      items {
        _id
        reference
        amount
        remarks
        provider
        status
        createdAt
        updatedAt
        currency
        bank {
          bankName
          accountNumber
          routingNumber
        }
        user {
          firstName
          lastName
        }
      }
      pagination
    }
  }
`;

export const GET_CHARGE_CONFIG = gql`
  query FetchChargeConfigs {
    fetchChargeConfigs(query: {}, pageOptions: { page: null, limit: null }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        name
        description
        chargeType
        chargeValue
        currency
        activityType
        isActive
      }
    }
  }
`;

export const GET_ADMIN_PERMISSIONS = gql`
  query GetAdminPermissions {
    getAdminPermissions {
      createdAt
      updatedAt
      _id
      feature
    }
  }
`;

export const GET_USER_PERMISSIONS = gql`
  query GetAdminRolePermissions {
    getAdminRolePermissions {
      createdAt
      updatedAt
      _id
      role {
        createdAt
        updatedAt
        _id
        title
        description
      }
      permission {
        createdAt
        updatedAt
        _id
        feature
      }
    }
  }
`;

export const GET_TOTAL_REWARD_GIVEN = gql`
  query GetTotalRewardsGiven {
    getTotalRewardsGiven {
      totalRewardsGiven
    }
  }
`;

export const GET_TOTAL_REFERRALS = gql`
  query TotalReferrals {
    totalReferrals {
      totalNoOfReferrals
    }
  }
`;

export const GET_ALL_REFERRALS = gql`
  query FetchAllReferrals {
    fetchAllReferrals(pageOptions: { page: null, limit: null }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        referralCode
        referrer {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          isDeleted
          previousEmail
          previousPhone
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
          referred
        }
        user {
          createdAt
          updatedAt
          _id
          uuid
          firstName
          lastName
          role
          imageUrl
          email
          phone
          sex
          dateOfBirth
          referralCode
          isDeleted
          previousEmail
          previousPhone
          verifiedAt
          profileStatus
          activityStatus
          coordinates
          registrationSource
          hasPaidMembershipFee
          hasRegistered
          hasCompletedSellerVerification
          stripeAccountId
          referred
        }
      }
    }
  }
`;

export const GET_CITY = gql`
  query GetCity($state: String!) {
    fetchCities(
      query: { state: $state }
      pageOptions: { page: 1, limit: null }
    ) {
      items {
        _id
        name
      }
      pagination
    }
  }
`;

export const GET_STATES = gql`
  query GetStates($country: String!) {
    fetchStates(
      query: { country: $country }
      pageOptions: { page: 1, limit: 100 }
    ) {
      items {
        _id
        name
        abbreviation
        country {
          _id
          name
        }
      }
      pagination
    }
  }
`;

export const GET_COUNTRIES = gql`
  query {
    getAllCountries(
      query: { name: "United" }
      pageOptions: { page: 1, limit: 150 }
    ) {
      items {
        _id
        name
        flagUrl
        dialingCode
      }
    }
  }
`;

export const GET_TOP_ORIGINS = gql`
  query GetTopProductOrigins {
    getTopProductOrigins {
      totalSold
      origin {
        createdAt
        updatedAt
        _id
        name
        alias
        flagUrl
        productCount
      }
    }
  }
`;

export const GET_INVESTOR_INQUIRIES = gql`
  query FetchInvestorInquiries($page: Float, $limit: Float) {
    fetchInvestorInquiries(pageOptions: { page: $page, limit: $limit }) {
      pagination
      items {
        createdAt
        updatedAt
        _id
        fullName
        email
        phoneNumber
        organization
        investmentRange
        heardAboutUs
        reasonForJoining
      }
    }
  }
`;
